import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=71aa4a5b"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"
import style0 from "./Insights.vue?vue&type=style&index=0&id=71aa4a5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports